import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppTenant } from './tenant/App';
import { BrowserRouter } from 'react-router-dom';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppTenant />
    </BrowserRouter>
  </React.StrictMode>,
);
